var map = {
	"./ar/default.json": 60265,
	"./ch/default.json": 81625,
	"./en/default.json": 2169,
	"./es/default.json": 46770,
	"./fl/default.json": 62756,
	"./fr/default.json": 45422,
	"./ga/default.json": 86458,
	"./id/default.json": 99079,
	"./il/default.json": 88047,
	"./it/default.json": 37911,
	"./nl/default.json": 15932,
	"./pl/default.json": 53698,
	"./ro/default.json": 57233,
	"./sp/default.json": 9009,
	"./sr/default.json": 34347,
	"./tr/default.json": 1460,
	"./uk/default.json": 60378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16349;